<template>
  <home-layout>
    <header-info :isMarketplace=true></header-info>
    <div class="container-fluid main__container">
      <div class="filters__wrapper">
        <div class="overlay__wrapper">
          <div class="background"></div>
          <img class="overlay__bg" src="../assets/marketplace/back-marketplace.jpg" />
        </div>
        <div class="heading">
          <h1 class="heading__title">Marketplace</h1>
          <span class="heading__subheading">Invierte desde $1,000 MXN</span>
        </div>
        <FiltersToolbar @on-change="changeFilter" :propertyTypes="propertyTypes" :locations="locations" :CoC="CoC" :IRR="IRR" v-on:change-view="changeViewStyle" />
      </div>
      <div class="property__list__wrapper">
        <div v-show="viewStyle === 'grid'" class="grid__list">
          <div v-for="(item, index) in properties" :key="index" class="grid__list-item">
            <CardItem :key="componentKey" :property="item" />
          </div>
        </div>
        <div :key="componentKey" v-show="viewStyle === 'list'" class="row__list">
          <HouseListItem v-for="(item, index) in properties" :key="index" :property="item" />
        </div>
      </div>
    </div>
    <button v-on:click="toggleShowFilters" class="handler__filters">
      <span>Filtros</span>
      <svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.20701 12.5H18.007M4.80701 7.69995H20.407M10.807 17.3H14.407" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <MobileFilters @on-change="changeFilter" :propertyTypes="propertyTypes" :locations="locations"  :show="showFilters" :CoC="CoC" :IRR="IRR" @hide="onHideMobileFilters" />
    <footer-info></footer-info>
  </home-layout>
</template>

<script>
import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import CardItem from '@/components/CardItem.vue'
import FiltersToolbar from '@/components/FiltersToolbar.vue'
import MobileFilters from '../components/ MobileFilters.vue'
import HouseListItem from '@/components/HouseListItem.vue'
import { getProperties, getLocations, getPropertyTypes, getPropertiesChange } from '../services/marketplace'
export default {
  name: 'Marketplace',
  props: {},
  data () {
    return {
      componentKey: 0,
      CoC:[],
      IRR:[],
      properties:[],
      locations:[],
      propertyTypes:[],
      valiteOption: true,
      validateSubOption: 0,
      showFilters: false,
      viewStyle: 'grid',
      valorDeveloper: {
        img: '',
        title: '',
        subtitle: '',
        description: ''
      }
    }
  },
  methods: {
    changeFilter(location, type, IRR, CoC){
      getPropertiesChange(location,type, IRR, CoC).then((response) => {
        console.log("response",response.data.data)
        this.properties = response.data.data
        this.componentKey += 1
      })
    },
    getLocations () {
      getLocations().then((response) => {
        console.log("response",response.data.data)
        this.locations = response.data.data
      })
    },
    getPropertyTypes () {
      getPropertyTypes().then((response) => {
        console.log("response",response.data.data)
        this.propertyTypes = response.data.data
      })
    },
    getProperties () {
      getProperties().then((response) => {
        console.log("response",response.data.data)
        this.properties = response.data.data
      })
    },
    deleteStyle () {
      this.changeStyle = ''
    },
    setStyle () {
      this.changeStyle = 'background-color: #0D051A;'
    },
    changeInvestorValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales1
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales4
      }
      this.valorDeveloper.title = this.valorInvestorAll[value].title
      this.valorDeveloper.subtitle = this.valorInvestorAll[value].subtitle
      this.valorDeveloper.description = this.valorInvestorAll[value].description
    },
    changeDeveloperValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales4
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales1
      }
      this.valorDeveloper.title = this.valorDeveloperAll[value].title
      this.valorDeveloper.subtitle = this.valorDeveloperAll[value].subtitle
      this.valorDeveloper.description = this.valorDeveloperAll[value].description
    },
    changeSubOption (value) {
      this.validateSubOption= value
      if (this.valiteOption) {
        this.changeInvestorValue(value)
      } else {
        this.changeDeveloperValue(value)
      }
    },
    changeOption (value) {
      this.valiteOption = value
      if (value) {
        this.changeSubOption(0)
        this.changeInvestorValue(0)
      } else {
        this.changeSubOption(0)
        this.changeDeveloperValue(0)
      }
    },
    changeViewStyle(style) {
      this.viewStyle = style;
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    onHideMobileFilters() {
      this.showFilters = false;
    },
  },
  created () {
    this.getProperties()
    this.getLocations()
    this.getPropertyTypes()
  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo,
    CardItem,
    FiltersToolbar,
    MobileFilters,
    HouseListItem
  },
}
</script>
